import { Pipe, } from "@angular/core";
import { DomSanitizer } from '@angular/platform-browser';
import { FireBaseService } from "../services/firebase.service";
import { PictureModel } from "../models/picture.model";
import * as firebase from 'firebase/app';
import { Observable } from "rxjs/Observable";
@Pipe({ name: 'asyncIMG' })
export class AsyncIMG {
    constructor(private fb: FireBaseService) { }

    transform(img) {
        if (img instanceof PictureModel) {
            return Observable.of(img);
        } else if (img instanceof firebase.firestore.DocumentReference) {
            var ref = <firebase.firestore.DocumentReference>img;
            return this.fb.getDoc<PictureModel>(ref.path);
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/pipes/asyncIMG.pipe.ts